import { createReducer, on } from '@ngrx/store';
import { setKeywords, setKeywordsMeta } from '../actions/util.actions';

export interface UtilState {
  restrictedKeywords: string[];
  restrictedSqlKeywords: string[];
  restrictedTableKeywords: string[];
  keywordsMeta: {
    etag: string;
    cacheTime: Date | null;
    maxAge: number;
  };
}

export const initialState: UtilState = {
  restrictedKeywords: [],
  restrictedSqlKeywords: [],
  restrictedTableKeywords: [],
  keywordsMeta: {
    etag: '',
    cacheTime: null,
    maxAge: 0
  }
};

export const utilReducer = createReducer(
  initialState,
  on(setKeywords, (state, { restrictedKeywords, restrictedSqlKeywords, restrictedTableKeywords }) => ({
    ...state,
    restrictedKeywords,
    restrictedSqlKeywords,
    restrictedTableKeywords
  })),
  on(setKeywordsMeta, (state, { keywordsMeta }) => ({
    ...state,
    keywordsMeta
  }))
);
